import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";

// Fontes empacotadas, não CDN (SPEC §13). Só os pesos que a interface usa —
// a folha completa de uma família traz dezenas de arquivos.
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "./estilo.css";

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Curadoria é trabalho de sessão longa com muita ida e volta entre
      // telas. Refazer toda consulta a cada foco de janela atrapalha mais do
      // que ajuda; o que muda sozinho (o agendador) pede recarga própria.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
